<template>
  <div id="page-wrapper" class="login-page-wrapper">
    <div id="page">
      <div class="main-page-content">
        <div id="main-wrapper" class="layout-main-wrapper clearfix">
          <div id="main" class="container">
            <div class="row row-offcanvas row-offcanvas-left clearfix">
              <main class="content-full-width" role="main">
                <section id="login" class="section">
                  <div class="d-login-container">
                    <div class="fptitle">
                      <span>{{ $t('message.reset_password') }}</span>

                    </div>
                    <form autocomplete="off" class="user-login-form" method="post" @submit.prevent="onSubmit()">

                      <input type="text" class="d-none" autocomplete="false">
                      <fieldset
                        class="position-relative js-form-item js-form-type-password form-type-password js-form-item-pass form-item-pass form-group">
                        <label for="edit-pass" class="js-form-required form-required">
                          {{ $t('message.password') }}
                        </label>
                        <input v-model="password" :type="showPass ? 'text' : 'password'" id="edit-pass" name="pass" size="60" maxlength="128"
                               placeholder="Enter your password" class="form-text required form-control">
                        <button type="button" class="score-c-4 mr-3 mb-2 togglepassword position-absolute btn btn-link p-0" @click.prevent.stop="showPass = !showPass">
                          <span v-if="!showPass" ><i class="fal fa-fw fa-eye"></i></span>
                          <span v-if="showPass" ><i class="fal fa-fw fa-eye-slash"></i></span>
                        </button>
                      </fieldset>
                      <fieldset
                        class="position-relative js-form-item js-form-type-textfield form-type-textfield js-form-item-name form-item-name form-group">
                        <label for="edit-pass-c" class="js-form-required form-required">
                          {{ $t('message.password_confirm') }}
                        </label>
                        <input v-model="passwordConfirmation" :type="showPassConfirm ? 'text' : 'password'" id="edit-pass-c" name="pass-c" size="60"
                               maxlength="128"
                               placeholder="Confirm your password" class="form-text required form-control">
                        <button type="button" class="score-c-4 mr-3 mb-2 togglepassword position-absolute btn btn-link p-0" @click.prevent.stop="showPassConfirm = !showPassConfirm">
                          <span v-if="!showPassConfirm" ><i class="fal fa-fw fa-eye"></i></span>
                          <span v-if="showPassConfirm" ><i class="fal fa-fw fa-eye-slash"></i></span>
                        </button>
                      </fieldset>
                      <div data-drupal-selector="edit-actions" class="form-actions js-form-wrapper form-group"
                           id="edit-actions">
                        <button type="submit" id="submit" name="login" value="Log in" class="button btn btn-primary">
                          {{ $t('message.confirm_reset') }}
                        </button>
                      </div>

                      <ul class="errors" v-if="errors.length">
                        <li class="text-danger" v-for="e in errors">{{e}}</li>
                      </ul>
                    </form>
                  </div>
                  <!--                  <div class="secondary-actions col-md-12 d-flex justify-content-between">-->
                  <!--                    <div></div>-->
                  <!--                    <button @click.stop.prevent="forgotPassword" class="pt-0 small btn btn-link text-white"><small-->
                  <!--                      class="pr-1">Forgot your password?</small></button>-->
                  <!--                  </div>-->
                </section>

              </main>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from "../../store/store";

  export default {
    data() {
      return {
        showPass:false,
        showPassConfirm:false,
        errors: [],
        password: '',
        passwordConfirmation: '',
        privateCode:this.$route.params.code,
      }
    },
    methods: {
      async onSubmit() {
        const el = document.querySelector('#submit');
        el.classList.add('loading');
        this.errors = [];
        const formData = {
          privateCode:this.privateCode,
          password: this.password,
          passwordConfirmation: this.passwordConfirmation,
        };
        store.dispatch('resetPassword', formData).then(r => {
          el.classList.remove('loading');
      //   console.log('reset', r)
          this.$router.push('/signin')
        })

      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Account/ResetPassword.vue